import Store from './../store'
import { richTextHelper } from './richTextHelper'

window.addEventListener('beforeunload', beforeunload)
export function beforeunload(event) {
  const noConfirmWhenHasUnsavedChange = Boolean(localStorage.getItem('noConfirmWhenHasUnsavedChange'))
  if (Store.state.historical_records.hasUnsavedChange && !noConfirmWhenHasUnsavedChange) {
    event.preventDefault()
    event.returnValue = ''
    return '您的修改尚未保存，确定要离开吗？'
  }
}

window.addEventListener('click', event => {
  handleContextMenu(event)
  handlePageTemplatePanel(event)
  handleModuleEditPanel(event)
})

window.addEventListener('mousedown', e => {
  // console.log(document.activeElement)

  if (document.activeElement.classList.contains('my-contenteditable')) {
    if (!document.getSelection().toString()) {
      // 如果没有选中一个字，就选整个挂件所有的字
      richTextHelper.select_text_widget(Store.state.widgets.module_Data.tid)
    }
    if ($(e.target).prop('tagName') === 'INPUT' || $(e.target).parents('.edit_item_font_size').length) {
      richTextHelper.saveSelection()
    }
    if ($(e.target).parents('#pane-module_style').length) {
      e.preventDefault()
    }
  }
  // if ($('.now_module_select .my-contenteditable').length) {
  //     if ($(e.target).parents('#pane-module_style').length) {
  //         e.preventDefault()
  //     }
  // }
})

document.addEventListener('selectionchange', () => {
  if ($(document.getSelection().anchorNode).parents('.my-text-wrapper').length) {
    Store.commit('color/set_selection_changed', true)
  }
})

function handlePageTemplatePanel(event) {
  if (
    Store.state.widgets.page_template_panel_visible &&
    !$(event.target).parents('.page-template-panel').length &&
    !$(event.target).parents('.page_item .icon_add').length
  ) {
    Store.commit('widgets/set_page_template_panel_visible', false)
  }
}

function handleModuleEditPanel(event) {
  if (Store.state.module_edit.is_show) {
    const $el = $(event.target)
    const isInCenter = !$el.parents('.module').length && $el.hasClass('module') && $el.hasClass('.center_frame').length
    if (isInCenter) {
      Store.commit('module_edit/SET_show', false)
    }
  }
}

function handleContextMenu(event) {
  const p = $(event.target).parent('.context-menu-list')
  if (p.length || p.hasClass('context-menu-list')) {
    return
  }
  Store.commit('contextmenu_dialog/SET_isShow', false)
}
